<script setup lang="ts">
import { useIsSp } from '@mp/hooks'

const Navs = [{ label: '首页', href: '/' }, { label: '产品中心', href: 'https://b.shengpay.com/prolist.html' }, { label: '开发者中心', href: 'https://docs.shengpay.com/%E4%BA%A7%E5%93%81%E8%83%BD%E5%8A%9B%E6%A6%82%E8%A7%88/' }, { label: '帮助中心', href: 'https://ann.shengpay.com/pages-ued/help-doc/index.html' }]

const { isNotSp, logo } = useIsSp()
</script>

<template>
  <header class=" bg-[#171f47] overflow-hidden h-[80px] flex items-center px-8 text-[#fff] pos-sticky w-screen top-0 z-50">
    <div class=" mr-[100px] flex items-center">
      <a href="/">
        <img v-if="isNotSp" :src="logo" class="block" alt="">
        <img v-else src="@/assets/logo.svg" class="block h-[33px]" alt="">
      </a>
      <span v-if="!isNotSp" class="text-lg inline-block b-l b-[#fff] b-l-solid line-height-none pl-4 ml-4">商户中心</span>
    </div>

    <nav v-if="!isNotSp" class="space-x-12 text-sm">
      <a v-for="item in Navs" :key="item.href" :href="item.href" class="  hover:text-[#fff]" :class="item.href === '/' ? 'text-[#fff]' : 'text-[#adc0ff]'">{{ item.label }}</a>
    </nav>
  </header>
</template>
